import { Typography, TableRow, TableRowProps, TableCell, styled } from '@mui/material'
import { ReactNode } from 'react'

interface Props extends TableRowProps {
  label?: string
  required?: boolean | string
  children?: ReactNode
}

const Row = styled(TableRow)({
  verticalAlign: 'top',
})

const Label = styled('label')({
  display: 'flex',
  minHeight: 40,
  alignItems: 'center',
})

function EditRow({ label, required, children, ...restProps }: Props) {
  return (
    <Row {...restProps}>
      <TableCell size={'small'} sx={{ maxWidth: '20em' }}>
        <Label>
          {label}
          {required && (
            <Typography display="inline" color="error">
              {' '}
              *
            </Typography>
          )}
        </Label>
      </TableCell>
      <TableCell size={'small'}>{children}</TableCell>
    </Row>
  )
}

export default EditRow
